<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-location-single-select-edit-control formControlName="outletGroupId" [(ngModel)]="model.data.outletGroupId" [readonly]="true"></wbo-location-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)] = "model.data.name" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-numeric-edit-control formControlName="serviceArea" [(ngModel)]="model.data.serviceArea"></wbo-numeric-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="code" [(ngModel)] = "model.data.code" ></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column formGroupName="discount">
                        <wbo-discount-single-select-edit-control formControlName="discountId" [(ngModel)]="model.data.discount.discountId" ></wbo-discount-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-currency-edit-control formControlName="spendLimit" [(ngModel)] = "model.data.spendLimit" ></wbo-currency-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
